var render, staticRenderFns
import script from "./WxAutocomplete.vue?vue&type=script&lang=js"
export * from "./WxAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./WxAutocomplete.vue?vue&type=style&index=0&id=591d32a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591d32a6",
  null
  
)

export default component.exports